
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11919',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11919",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.456",
  "dashboard-client-types": "static-1.316",
  "data-fetching-client": "static-1.9571",
  "foundations-components": "static-1.7715",
  "foundations-components-legacy": "static-1.740",
  "foundations-theming": "static-1.4309",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.80",
  "head-dlb": "static-1.4921",
  "hs-test-utils": "static-1.7907",
  "hub-http-shared-msw-handlers": "static-1.9724",
  "hubspot-dlb": "static-2.1828",
  "hubspot-url-utils": "static-1.4034",
  "HubStyleTokens": "static-2.11348",
  "I18n": "static-7.1602",
  "jasmine-runner": "static-1.6365",
  "marketplace-storefront-base": "static-1.11980",
  "quartz": "static-1.6863",
  "react-dlb": "static-1.76",
  "react-rhumb": "static-1.16550",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2758",
  "reporting-testing-lib": "static-1.8943",
  "settings-ui-lib": "static-1.12421",
  "SharedI18nStrings": "static-1.181",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6946",
  "ui-addon-i18n": "static-1.11043",
  "ui-addon-react-router-dom": "static-1.9440",
  "unified-auth": "static-1.344",
  "unified-auth-core-lib": "static-1.625",
  "usage-tracker": "static-1.7232",
  "usage-tracker-core": "static-1.7082",
  "customer-data-property-utils": "static-1.7979",
  "history": "static-4.47",
  "hub-http": "static-1.6115",
  "integrations-lib": "static-1.15774",
  "marketplace-ui-common": "static-1.19293",
  "property-management-iframe": "static-1.12798",
  "quartz-config": "static-1.641",
  "quartz-core": "static-1.6082",
  "quartz-routing": "static-1.293",
  "quick-fetch": "static-1.3831",
  "react": "static-7.184",
  "rpc-client-utils": "static-1.4540",
  "ts-schema": "static-1.3993",
  "ui-universal-auth": "static-1.8830",
  "UIComponents": "static-3.8295",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.425",
  "hs-promise-rejection-tracking": "static-1.5473",
  "PortalIdParser": "static-2.386",
  "raven": "static-3.5808",
  "raven-hubspot": "static-1.6115",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.76",
  "metrics-js": "static-1.9522",
  "react-redux": "static-7.69",
  "redux": "static-4.16",
  "styled-components": "static-2.87",
  "bend-plugin-trellis-migration": "static-1.3321",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3140",
  "quartz-webpack": "static-1.3087",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3984",
  "floating-ui": "static-1.54",
  "foundations-assets": "static-1.4743",
  "foundations-theming-specialty": "static-1.2025",
  "framer-motion": "static-1.70",
  "hs-story-utils": "static-1.9326",
  "react-aria": "static-1.64",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5263",
  "react-virtualized": "static-2.97",
  "StyleGuideUI": "static-3.485",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1521",
  "ui-fonts": "static-1.610",
  "ui-images": "static-2.1127",
  "bend-plugin-foundations-theming": "static-1.2792",
  "foundations-theming-base": "static-1.3294",
  "stylex": "static-1.30",
  "HeadJS": "static-2.735",
  "hs-test-utils-bend-plugin": "static-1.3018",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4220",
  "ai-components-ui-library": "static-1.8672",
  "ai-rendering-library": "static-1.9700",
  "chirp-fetch": "static-1.1777",
  "connections-embed-lib": "static-1.787",
  "copilot-toolkit": "static-1.10836",
  "laboratory-lib": "static-3.7055",
  "marketplace-embed": "static-1.21781",
  "marketplace-ui-details": "static-1.9189",
  "marketplace-ui-reviews": "static-1.19249",
  "marketplace-ui-tracking": "static-1.13464",
  "sanitize-text": "static-1.8041",
  "ui-addon-video-player": "static-1.8592",
  "usage-tracker-multi": "static-1.5646",
  "usage-tracker-session-replay": "static-1.4918",
  "wootric-nps": "static-1.6880",
  "apollo-link-hub-http": "static-2.4547",
  "immer": "static-1.33",
  "immerable": "static-1.4049",
  "highcharts": "static-8.102",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2427",
  "reporting-data": "static-1.67010",
  "cssUtils": "static-1.767",
  "flux-actions": "static-1.325",
  "HubStyle": "static-2.11656",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10105",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10270",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7222",
  "icons": "static-2.639",
  "marketplace-ui-apps-core": "static-1.17826",
  "storybook-react": "static-1.31",
  "trellis-story-utils": "static-1.4415",
  "foundations-components-test-utils": "static-1.5198",
  "quartz-i18n": "static-1.538",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3629",
  "customer-data-objects": "static-1.7552",
  "property-translator": "static-1.5304",
  "frontend-preferences-client": "static-1.7820",
  "hs-promise-utils": "static-1.5490",
  "hubspot-apollo-client": "static-1.4774",
  "integrations-error-boundary-lib": "static-1.13189",
  "integrations-tracking-lib": "static-1.5491",
  "native-integrations-shared-strings": "static-1.7682",
  "reselect": "static-2.16",
  "sanitize": "static-1.4369",
  "superstore": "static-1.4665",
  "ui-shepherd-react": "static-3.10043",
  "ai-settings-ui-library": "static-1.7716",
  "hub-http-janus": "static-1.819",
  "hubspotter-http": "static-1.4567",
  "immutable-less": "static-1.4549",
  "marketplace-ui-client-types": "static-1.16700",
  "nav-meta": "static-1.29277",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10141",
  "ui-addon-upgrades": "static-9.17837",
  "inbound-db-properties-service-client": "static-1.3761",
  "property-management-common": "static-1.5086",
  "ui-addon-iframeable": "static-1.8945",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.508",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.538",
  "quartz-head": "static-1.528",
  "quartz-test": "static-1.538",
  "quartz-tracking": "static-1.242",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3062",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20797",
  "ContentUtils": "static-1.68032",
  "sassPrefix": "static-1.154",
  "avatar-components": "static-1.2390",
  "customer-data-filters-ui": "static-1.39344",
  "customer-data-objects-ui-components": "static-1.12914",
  "customer-data-reference-ui-components": "static-1.13049",
  "embedded-academy-lib": "static-1.13942",
  "ExportDialog": "static-6.10287",
  "highlight.js": "static-1.77",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40967",
  "reporting-snowflake": "static-1.55628",
  "reporting-ui-components": "static-2.64281",
  "reporting-visualizations": "static-1.59086",
  "ui-addon-teams": "static-1.21405",
  "magpie-lib": "static-1.5489",
  "magpie-types": "static-1.4949",
  "simple-logging-lib": "static-1.2947",
  "navigation-components": "static-1.17640",
  "ai-studio-lib": "static-1.11303",
  "app-governance-lib": "static-1.1224",
  "developer-experience-shared-components": "static-1.10403",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7887",
  "ui-product-approvals": "static-1.27842",
  "ui-tool-access": "static-1.10043",
  "usage-based-billing-components-lib": "static-1.8320",
  "usage-tracker-anonymous": "static-1.5649",
  "usage-tracker-public": "static-1.7043",
  "amplitude-session-replay-browser": "static-1.58",
  "inbound-db-meta-service-client": "static-1.3504",
  "persist-promise": "static-1.3605",
  "reference-resolvers": "static-1.8063",
  "ui-extensibility-client-types": "static-1.3835",
  "hubspot-apollo-cache": "static-1.233",
  "universal-page-editor-lib": "static-1.2902",
  "final-form": "static-1.68",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2483",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4967",
  "purchase-motions-components": "static-1.5675",
  "salesImages": "static-1.523",
  "batch-promise": "static-1.1448",
  "crm-component-utils": "static-1.38782",
  "crm-properties-common-lib": "static-1.5771",
  "customer-data-properties": "static-1.51174",
  "framework-data-schema-resolvers": "static-1.6771",
  "property-value-citations": "static-1.1788",
  "reference-resolvers-lite": "static-1.7985",
  "navigation-messaging": "static-1.6967",
  "hubspotter-http-shared-msw-handlers": "static-1.9722",
  "cms-field-types": "static-1.4705",
  "content-icons-ui": "static-1.2200",
  "conversations-skeleton-state": "static-1.7145",
  "crm-message-bus": "static-1.42692",
  "customer-data-filters-ui-msw-helpers": "static-1.21779",
  "customer-data-ui-utilities": "static-1.9721",
  "FormUrlGenerator": "static-2.4615",
  "framework-builder-read-service-client": "static-1.3923",
  "framework-data-schema-quick-fetch": "static-1.6676",
  "multi-account-reference-resolvers": "static-1.873",
  "onboarding-tours": "static-1.16412",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13375",
  "academy-common-lib": "static-1.13402",
  "content-assistance-lib": "static-1.7597",
  "dashboard-lib": "static-1.81086",
  "file-manager-components": "static-1.23286",
  "getting-started-shared-tasks": "static-1.18200",
  "hubspot-prosemirror": "static-1.17934",
  "hubspot-prosemirror-plugins": "static-1.17926",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19651",
  "share-with-third-party-component-lib": "static-1.8591",
  "ui-addon-draggable": "static-3.4665",
  "ui-asset-management-lib": "static-1.10876",
  "ui-business-units-lib": "static-1.8936",
  "user-context": "static-1.4995",
  "growth-payments-core": "static-1.25053",
  "reporting-plugins": "static-1.10131",
  "reporting-reports": "static-1.66688",
  "idb-keyval": "static-1.42",
  "reactive-lib": "static-1.620",
  "nest": "static-1.118",
  "codemirror": "static-5.93",
  "feedback-loader": "static-1.29102",
  "react-codemirror": "static-1.10520",
  "framework-listing-lib": "static-2.28367",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30435",
  "apps-service-types": "static-1.3773",
  "oauth-service-types": "static-1.4145",
  "onboarding-scopes": "static-1.6359",
  "onboarding-tours-client": "static-1.4626",
  "platform-infra-nav-components": "static-1.7581",
  "subscription-experience-data-types": "static-1.14732",
  "crm-record-cards-service-types": "static-1.3525",
  "location-customization-utils-lib": "static-1.8911",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4398",
  "nav-client-types": "static-1.2254",
  "purchase-motions-api": "static-1.5678",
  "signup-constants": "static-1.18650",
  "signup-ui-url-generator": "static-2.7936",
  "trials-service-types": "static-1.3799",
  "card-properties-lib": "static-1.43856",
  "commerce-subscription-lib": "static-1.36791",
  "crm-actions": "static-1.6210",
  "crm-cards-sdk": "static-1.43264",
  "customer-data-properties-shared-msw-handlers": "static-1.9051",
  "customer-data-tracking": "static-1.6780",
  "hs-resources": "static-1.34",
  "pulse": "static-1.436",
  "calling-global-api": "static-1.64092",
  "calling-internal-common": "static-1.31197",
  "calling-lifecycle-internal": "static-1.65474",
  "calling-lifecycle-messages": "static-1.57768",
  "commerce-products-lib": "static-1.9146",
  "conditional-properties-service-client": "static-1.3712",
  "crm-links": "static-1.6171",
  "external-options-client-types": "static-1.4073",
  "google-libphonenumber": "static-1.36",
  "inbounddb-objects-service-types": "static-1.4138",
  "meetings-icalendar-utils-lib": "static-1.526",
  "multi-currency-client-types": "static-1.3605",
  "object-builder-ui-client": "static-1.48386",
  "pipeline-validation-client-types": "static-1.3880",
  "smart-property-lib": "static-1.6423",
  "tiered-pricing": "static-1.1007",
  "ui-addon-form-validation": "static-1.10887",
  "crm-pipelines-api-client-types": "static-1.4057",
  "react-dnd-compat": "static-1.4514",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5269",
  "growth-onboarding-confetti": "static-1.2967",
  "growth-onboarding-next-action-utils": "static-1.1608",
  "onboarding-tours-utils": "static-1.478",
  "ui-shepherd-tracker": "static-1.7424",
  "academy-service-client": "static-1.3577",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28248",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8278",
  "video-components-external": "static-1.10936",
  "video-data-lib": "static-1.34594",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8440",
  "payment-link-components": "static-1.23235",
  "ui-addon-emoji-picker": "static-1.9783",
  "EmailSignatureEditor": "static-1.24145",
  "viral-links-lib": "static-1.6936",
  "data-token-picker": "static-1.16222",
  "FileManagerLib": "static-1.38926",
  "react-flip-move": "static-1.68",
  "nested-table": "static-1.118",
  "timezone-utils": "static-2.5140",
  "getting-started-shared-tasks-store": "static-1.17318",
  "campaign-roi-lib": "static-1.8628",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7220",
  "customer-data-views-management": "static-1.25217",
  "framework-data-table": "static-2.11672",
  "marketing-platform-lib": "static-1.6745",
  "nudge-client-utils": "static-1.2354",
  "nudge-custom-ui-functions": "static-1.844",
  "app-users-service-client": "static-1.5454",
  "app-users-service-types": "static-1.4862",
  "mini-checkout-client": "static-1.26561",
  "onboarding-utils": "static-1.5248",
  "permissions-shared-i18n-strings-fe": "static-1.2005",
  "ui-coaching-tips-shared-config": "static-1.28233",
  "edison-service-client-types": "static-1.283",
  "eligibility-engine-service-types": "static-1.3080",
  "crm_data": "static-4.91620",
  "customer-data-sidebar": "static-2.45716",
  "enrichment-properties-lib": "static-1.15541",
  "commerce-billing-lib": "static-1.18789",
  "commerce-shared-components-lib": "static-1.18256",
  "commerce-tools-ui-lib": "static-1.10101",
  "crm-fe-perf": "static-1.22799",
  "directed-graph": "static-1.833",
  "event-emitter": "static-1.844",
  "fast-json-patch": "static-1.61",
  "calling-error-reporting": "static-1.31203",
  "shared-worker-versioning": "static-1.10934",
  "calling-usage-tracker": "static-1.6437",
  "voice-sms-access-library": "static-1.591",
  "commerce-permissions": "static-1.661",
  "products-iframe-lib": "static-1.7635",
  "products-ui-components-shared-msw-handlers": "static-1.10106",
  "data-agent-kit": "static-1.27",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9807",
  "policy-lib": "static-1.6678",
  "react-tinymce": "static-1.54937",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9870",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54063",
  "tinymce-plugins": "static-1.57177",
  "tinymce-themes": "static-1.56033",
  "onboarding-data-sync-lib": "static-1.1785",
  "growth-onboarding-next-action-components": "static-1.1636",
  "user-context-client": "static-1.4508",
  "growth-onboarding-feedback-components": "static-1.6478",
  "content-media-composition-data-lib": "static-1.11893",
  "content-media-compositions": "static-2.15900",
  "media-bridge-lib": "static-1.18742",
  "commerce-tours-lib": "static-1.5903",
  "growth-onboarding-reliability": "static-1.4982",
  "sales-checkout-service-client": "static-1.3564",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21491",
  "sales-email-signature-service-client": "static-1.3739",
  "audio-components": "static-1.5759",
  "FileManagerCore": "static-1.38785",
  "FileManagerImages": "static-1.36437",
  "video-components": "static-1.12939",
  "crm-export-dialog": "static-1.6192",
  "crm-index-associations-lib": "static-1.6331",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1636",
  "tanstack-virtual": "static-1.28",
  "nudge-custom-function-registry": "static-1.2111",
  "nudge-renderer-utils": "static-1.2430",
  "whisper-core-api": "static-1.6297",
  "InboxConnectUtils": "static-4.14521",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5280",
  "settings-content-modals": "static-1.45779",
  "crm_universal": "static-1.21824",
  "customer-data-email": "static-1.17852",
  "card-payment-highlight-lib": "static-1.36844",
  "card-subscription-highlight-lib": "static-1.39214",
  "commerce-contract-lib": "static-1.11597",
  "invoices-highlight-card-lib": "static-1.54370",
  "orders-highlight-card-lib": "static-1.21168",
  "products-highlight-card-lib": "static-1.17430",
  "quotes-highlight-card-lib": "static-1.71595",
  "breeze-intelligence-kit": "static-1.5470",
  "crm-source-interpretation-lib": "static-1.5230",
  "utility-belt": "static-1.2436",
  "payments-enrollment-embed-lib": "static-1.22331",
  "stripe-embedded-components": "static-1.7321",
  "customer-data-rte": "static-1.32725",
  "cv-backend-services": "static-1.1537",
  "growth-onboarding-empty-states": "static-1.5527",
  "payments-post-enroll-local-storage-lib": "static-1.5007",
  "qrcode-generator": "static-1.67",
  "quotes-client-types": "static-1.37685",
  "calling-orchestration-schema": "static-1.35368",
  "sales-views-client-types": "static-1.4159",
  "hub-http-contrib": "static-1.2939",
  "interframe": "static-3.4659",
  "tinymce-data": "static-1.40148",
  "ui-addon-sales-email": "static-1.5107",
  "layout-dnd-components": "static-1.12242",
  "layout-dnd-utils": "static-1.11217",
  "ui-brand-identity-lib": "static-1.14773",
  "NamespacedHubStyle": "static-2.8984",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4428",
  "video-embed": "static-1.35428",
  "social-insights-client-types": "static-1.21774",
  "deal-intel-utils": "static-1.1640",
  "checkout-sdk": "static-3.23404",
  "checkout-service-types": "static-1.3742",
  "company-details-components": "static-1.6081",
  "payment-method-components": "static-1-sai-jledford-autofill-pos-ae9c.3",
  "pricing-pages-ui-components": "static-1.13252",
  "quote-checkout-service-types": "static-1.3370",
  "upgrade-catalog-service-types": "static-1.3423",
  "access-control-lib": "static-1.10334",
  "EmailComponents": "static-1.54466",
  "EmailData": "static-1.53143",
  "redux-less": "static-2.9380",
  "sequences-lib": "static-1.7861",
  "ui-gdpr-components": "static-1.10244",
  "products-ui-components": "static-1.39665",
  "quotes-ui-lib": "static-1.80316",
  "accounting-integrations-ui-components": "static-1.6894",
  "invoices-ui-lib": "static-1.54386",
  "commerce-products-api": "static-1.2133",
  "invoices-iframe-lib": "static-1.56444",
  "quotes-modal-lib": "static-1.102273",
  "stripe-connect-js": "static-1.66",
  "draft-content-plugins": "static-1.27992",
  "ContentData": "static-1.68107",
  "layout-data-lib": "static-1.9542",
  "billing-payments-client-types": "static-1.3886",
  "outpost": "static-1.4091",
  "hub-http-rxjs": "static-1.785",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3826",
  "account-and-billing-fintech-outages": "static-3.18386",
  "pricing-pages-api": "static-1.13117",
  "ContentComponents": "static-2.70988",
  "marketing-contacts-lib": "static-1.9521",
  "marketing-email-service-types": "static-1.1837",
  "messaging-editing-lib": "static-1.45939",
  "messaging-usage-based-billing-components-lib": "static-1.801",
  "automation-ui-source-apps": "static-1.18566",
  "automation-ui-types": "static-1.19484",
  "messaging-types-lib": "static-1.45676",
  "onboarding-settings-client": "static-1.4399",
  "sequences-client-types-lib": "static-1.7718",
  "commerce-tax-lib": "static-1.415",
  "property-description-translator": "static-1.3749",
  "SalesContentIndexUI": "static-3.9080",
  "commerce-analytics-service-client": "static-1.3552",
  "totals-ui-components": "static-1.23291",
  "advanced-menus-core": "static-1.14967",
  "advanced-menus-lib": "static-1.11929",
  "ui-memberships-settings-lib": "static-1.33753",
  "demographics-service-types": "static-1.1548",
  "automation-ui-ubb": "static-1.5400",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7236",
  "data-token-views": "static-1.16203",
  "forms-utils-lib": "static-1.12384",
  "payments-embed-points-lib": "static-1.12825",
  "simple-menus-core": "static-1.14966",
  "simple-menus-lib": "static-1.16483",
  "ui-addon-draggable-compat": "static-2.4150",
  "videoconference-integration-components": "static-1.6670",
  "automation-applications-service-types": "static-1.3417",
  "automation-platform-service-types": "static-1.2552",
  "ContentEditorUI": "static-2.76806",
  "short-messages-app-service-client": "static-1.3877",
  "web-interactives-components": "static-1.13582",
  "web-interactives-data": "static-1.13583",
  "messaging-shared-utils-lib": "static-1.250",
  "messaging-user-info-utils-lib": "static-1.420",
  "email-portal-health-service-types": "static-1.872",
  "FireAlarmUi": "static-1.4425",
  "sales-templates-service-types-lib": "static-1.4082",
  "commerce-totals-service-types": "static-1.3732",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21420",
  "automation-ui-usage-tracking": "static-1.20883",
  "data-studio-ubb": "static-1.2419",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26722",
  "collaboration-sidebar": "static-1.57468",
  "content-management-data-lib": "static-1.5255",
  "copilot-plugins": "static-1.10809",
  "cta-picker": "static-1.36127",
  "customer-agent-discovery-components-lib": "static-1.2758",
  "editor-components": "static-1.13079",
  "editor-iframe-lib": "static-1.8258",
  "error-messaging-js": "static-1.5088",
  "FormsCommonComponents": "static-1.85569",
  "pictos": "static-7.182",
  "react-transition-group": "static-2.63",
  "redux-request-state": "static-1.10542",
  "SharedLegalStrings": "static-1.1647",
  "smart-content-core": "static-1.42154",
  "smart-content-lib": "static-1.42807",
  "social-composer-lib": "static-1.58556",
  "structured-content-lib": "static-1.24911",
  "theme-previewer-lib": "static-1.52966",
  "tinymce-copilot": "static-1.16131",
  "xray-recommendation-lib": "static-1.7756",
  "automation-ui-routing": "static-1.20841",
  "sql-reporting-client-types": "static-1.5556",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.41925",
  "campaigns-utils-lib": "static-1.3055",
  "reporting-enablement": "static-1.22498",
  "chatspot-widget-iframe": "static-1.20789",
  "collaboration-sidebar-common": "static-1.2265",
  "forms-ai-lib": "static-1.4155",
  "codemirror-dlb": "static-1.58365",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6324",
  "report-customization-components": "static-1.12826",
  "data-quality-ui-library": "static-1.12599",
  "html-to-image": "static-1.52",
  "reporting-insights-lib": "static-1.1408"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11919",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.456",
  "dashboard-client-types": "/dashboard-client-types/static-1.316",
  "data-fetching-client": "/data-fetching-client/static-1.9571",
  "foundations-components": "/foundations-components/static-1.7715",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.740",
  "foundations-theming": "/foundations-theming/static-1.4309",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.80",
  "head-dlb": "/head-dlb/static-1.4921",
  "hs-test-utils": "/hs-test-utils/static-1.7907",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9724",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "HubStyleTokens": "/HubStyleTokens/static-2.11348",
  "I18n": "/I18n/static-7.1602",
  "jasmine-runner": "/jasmine-runner/static-1.6365",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11980",
  "quartz": "/quartz/static-1.6863",
  "react-dlb": "/react-dlb/static-1.76",
  "react-rhumb": "/react-rhumb/static-1.16550",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2758",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8943",
  "settings-ui-lib": "/settings-ui-lib/static-1.12421",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6946",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11043",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9440",
  "unified-auth": "/unified-auth/static-1.344",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.625",
  "usage-tracker": "/usage-tracker/static-1.7232",
  "usage-tracker-core": "/usage-tracker-core/static-1.7082",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7979",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6115",
  "integrations-lib": "/integrations-lib/static-1.15774",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19293",
  "property-management-iframe": "/property-management-iframe/static-1.12798",
  "quartz-config": "/quartz-config/static-1.641",
  "quartz-core": "/quartz-core/static-1.6082",
  "quartz-routing": "/quartz-routing/static-1.293",
  "quick-fetch": "/quick-fetch/static-1.3831",
  "react": "/react/static-7.184",
  "rpc-client-utils": "/rpc-client-utils/static-1.4540",
  "ts-schema": "/ts-schema/static-1.3993",
  "ui-universal-auth": "/ui-universal-auth/static-1.8830",
  "UIComponents": "/UIComponents/static-3.8295",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.425",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5473",
  "PortalIdParser": "/PortalIdParser/static-2.386",
  "raven": "/raven/static-3.5808",
  "raven-hubspot": "/raven-hubspot/static-1.6115",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.76",
  "metrics-js": "/metrics-js/static-1.9522",
  "react-redux": "/react-redux/static-7.69",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.87",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3321",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3140",
  "quartz-webpack": "/quartz-webpack/static-1.3087",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3984",
  "floating-ui": "/floating-ui/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4743",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2025",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-story-utils": "/hs-story-utils/static-1.9326",
  "react-aria": "/react-aria/static-1.64",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5263",
  "react-virtualized": "/react-virtualized/static-2.97",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1521",
  "ui-fonts": "/ui-fonts/static-1.610",
  "ui-images": "/ui-images/static-2.1127",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2792",
  "foundations-theming-base": "/foundations-theming-base/static-1.3294",
  "stylex": "/stylex/static-1.30",
  "HeadJS": "/HeadJS/static-2.735",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3018",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4220",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8672",
  "ai-rendering-library": "/ai-rendering-library/static-1.9700",
  "chirp-fetch": "/chirp-fetch/static-1.1777",
  "connections-embed-lib": "/connections-embed-lib/static-1.787",
  "copilot-toolkit": "/copilot-toolkit/static-1.10836",
  "laboratory-lib": "/laboratory-lib/static-3.7055",
  "marketplace-embed": "/marketplace-embed/static-1.21781",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9189",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19249",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13464",
  "sanitize-text": "/sanitize-text/static-1.8041",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8592",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5646",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4918",
  "wootric-nps": "/wootric-nps/static-1.6880",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4547",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4049",
  "highcharts": "/highcharts/static-8.102",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2427",
  "reporting-data": "/reporting-data/static-1.67010",
  "cssUtils": "/cssUtils/static-1.767",
  "flux-actions": "/flux-actions/static-1.325",
  "HubStyle": "/HubStyle/static-2.11656",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10105",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10270",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7222",
  "icons": "/icons/static-2.639",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17826",
  "storybook-react": "/storybook-react/static-1.31",
  "trellis-story-utils": "/trellis-story-utils/static-1.4415",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5198",
  "quartz-i18n": "/quartz-i18n/static-1.538",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3629",
  "customer-data-objects": "/customer-data-objects/static-1.7552",
  "property-translator": "/property-translator/static-1.5304",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7820",
  "hs-promise-utils": "/hs-promise-utils/static-1.5490",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4774",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13189",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5491",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7682",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4369",
  "superstore": "/superstore/static-1.4665",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10043",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7716",
  "hub-http-janus": "/hub-http-janus/static-1.819",
  "hubspotter-http": "/hubspotter-http/static-1.4567",
  "immutable-less": "/immutable-less/static-1.4549",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16700",
  "nav-meta": "/nav-meta/static-1.29277",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10141",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17837",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3761",
  "property-management-common": "/property-management-common/static-1.5086",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8945",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.508",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.538",
  "quartz-head": "/quartz-head/static-1.528",
  "quartz-test": "/quartz-test/static-1.538",
  "quartz-tracking": "/quartz-tracking/static-1.242",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3062",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20797",
  "ContentUtils": "/ContentUtils/static-1.68032",
  "sassPrefix": "/sassPrefix/static-1.154",
  "avatar-components": "/avatar-components/static-1.2390",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39344",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12914",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13049",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13942",
  "ExportDialog": "/ExportDialog/static-6.10287",
  "highlight.js": "/highlight.js/static-1.77",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40967",
  "reporting-snowflake": "/reporting-snowflake/static-1.55628",
  "reporting-ui-components": "/reporting-ui-components/static-2.64281",
  "reporting-visualizations": "/reporting-visualizations/static-1.59086",
  "ui-addon-teams": "/ui-addon-teams/static-1.21405",
  "magpie-lib": "/magpie-lib/static-1.5489",
  "magpie-types": "/magpie-types/static-1.4949",
  "simple-logging-lib": "/simple-logging-lib/static-1.2947",
  "navigation-components": "/navigation-components/static-1.17640",
  "ai-studio-lib": "/ai-studio-lib/static-1.11303",
  "app-governance-lib": "/app-governance-lib/static-1.1224",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10403",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7887",
  "ui-product-approvals": "/ui-product-approvals/static-1.27842",
  "ui-tool-access": "/ui-tool-access/static-1.10043",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8320",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5649",
  "usage-tracker-public": "/usage-tracker-public/static-1.7043",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3504",
  "persist-promise": "/persist-promise/static-1.3605",
  "reference-resolvers": "/reference-resolvers/static-1.8063",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3835",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.233",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2902",
  "final-form": "/final-form/static-1.68",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2483",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4967",
  "purchase-motions-components": "/purchase-motions-components/static-1.5675",
  "salesImages": "/salesImages/static-1.523",
  "batch-promise": "/batch-promise/static-1.1448",
  "crm-component-utils": "/crm-component-utils/static-1.38782",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5771",
  "customer-data-properties": "/customer-data-properties/static-1.51174",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6771",
  "property-value-citations": "/property-value-citations/static-1.1788",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7985",
  "navigation-messaging": "/navigation-messaging/static-1.6967",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9722",
  "cms-field-types": "/cms-field-types/static-1.4705",
  "content-icons-ui": "/content-icons-ui/static-1.2200",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7145",
  "crm-message-bus": "/crm-message-bus/static-1.42692",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21779",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9721",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4615",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3923",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6676",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.873",
  "onboarding-tours": "/onboarding-tours/static-1.16412",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13375",
  "academy-common-lib": "/academy-common-lib/static-1.13402",
  "content-assistance-lib": "/content-assistance-lib/static-1.7597",
  "dashboard-lib": "/dashboard-lib/static-1.81086",
  "file-manager-components": "/file-manager-components/static-1.23286",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18200",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17934",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17926",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19651",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8591",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4665",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10876",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8936",
  "user-context": "/user-context/static-1.4995",
  "growth-payments-core": "/growth-payments-core/static-1.25053",
  "reporting-plugins": "/reporting-plugins/static-1.10131",
  "reporting-reports": "/reporting-reports/static-1.66688",
  "idb-keyval": "/idb-keyval/static-1.42",
  "reactive-lib": "/reactive-lib/static-1.620",
  "nest": "/nest/static-1.118",
  "codemirror": "/codemirror/static-5.93",
  "feedback-loader": "/feedback-loader/static-1.29102",
  "react-codemirror": "/react-codemirror/static-1.10520",
  "framework-listing-lib": "/framework-listing-lib/static-2.28367",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30435",
  "apps-service-types": "/apps-service-types/static-1.3773",
  "oauth-service-types": "/oauth-service-types/static-1.4145",
  "onboarding-scopes": "/onboarding-scopes/static-1.6359",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4626",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7581",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14732",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3525",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8911",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4398",
  "nav-client-types": "/nav-client-types/static-1.2254",
  "purchase-motions-api": "/purchase-motions-api/static-1.5678",
  "signup-constants": "/signup-constants/static-1.18650",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7936",
  "trials-service-types": "/trials-service-types/static-1.3799",
  "card-properties-lib": "/card-properties-lib/static-1.43856",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36791",
  "crm-actions": "/crm-actions/static-1.6210",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43264",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9051",
  "customer-data-tracking": "/customer-data-tracking/static-1.6780",
  "hs-resources": "/hs-resources/static-1.34",
  "pulse": "/pulse/static-1.436",
  "calling-global-api": "/calling-global-api/static-1.64092",
  "calling-internal-common": "/calling-internal-common/static-1.31197",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65474",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57768",
  "commerce-products-lib": "/commerce-products-lib/static-1.9146",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3712",
  "crm-links": "/crm-links/static-1.6171",
  "external-options-client-types": "/external-options-client-types/static-1.4073",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4138",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.526",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3605",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48386",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3880",
  "smart-property-lib": "/smart-property-lib/static-1.6423",
  "tiered-pricing": "/tiered-pricing/static-1.1007",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10887",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4057",
  "react-dnd-compat": "/react-dnd-compat/static-1.4514",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5269",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2967",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1608",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.478",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7424",
  "academy-service-client": "/academy-service-client/static-1.3577",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28248",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8278",
  "video-components-external": "/video-components-external/static-1.10936",
  "video-data-lib": "/video-data-lib/static-1.34594",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8440",
  "payment-link-components": "/payment-link-components/static-1.23235",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9783",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24145",
  "viral-links-lib": "/viral-links-lib/static-1.6936",
  "data-token-picker": "/data-token-picker/static-1.16222",
  "FileManagerLib": "/FileManagerLib/static-1.38926",
  "react-flip-move": "/react-flip-move/static-1.68",
  "nested-table": "/nested-table/static-1.118",
  "timezone-utils": "/timezone-utils/static-2.5140",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17318",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8628",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7220",
  "customer-data-views-management": "/customer-data-views-management/static-1.25217",
  "framework-data-table": "/framework-data-table/static-2.11672",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6745",
  "nudge-client-utils": "/nudge-client-utils/static-1.2354",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.844",
  "app-users-service-client": "/app-users-service-client/static-1.5454",
  "app-users-service-types": "/app-users-service-types/static-1.4862",
  "mini-checkout-client": "/mini-checkout-client/static-1.26561",
  "onboarding-utils": "/onboarding-utils/static-1.5248",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2005",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28233",
  "edison-service-client-types": "/edison-service-client-types/static-1.283",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3080",
  "crm_data": "/crm_data/static-4.91620",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45716",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15541",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18789",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18256",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10101",
  "crm-fe-perf": "/crm-fe-perf/static-1.22799",
  "directed-graph": "/directed-graph/static-1.833",
  "event-emitter": "/event-emitter/static-1.844",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "calling-error-reporting": "/calling-error-reporting/static-1.31203",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10934",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6437",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.591",
  "commerce-permissions": "/commerce-permissions/static-1.661",
  "products-iframe-lib": "/products-iframe-lib/static-1.7635",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10106",
  "data-agent-kit": "/data-agent-kit/static-1.27",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9807",
  "policy-lib": "/policy-lib/static-1.6678",
  "react-tinymce": "/react-tinymce/static-1.54937",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9870",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54063",
  "tinymce-plugins": "/tinymce-plugins/static-1.57177",
  "tinymce-themes": "/tinymce-themes/static-1.56033",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1785",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1636",
  "user-context-client": "/user-context-client/static-1.4508",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6478",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11893",
  "content-media-compositions": "/content-media-compositions/static-2.15900",
  "media-bridge-lib": "/media-bridge-lib/static-1.18742",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5903",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4982",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3564",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21491",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3739",
  "audio-components": "/audio-components/static-1.5759",
  "FileManagerCore": "/FileManagerCore/static-1.38785",
  "FileManagerImages": "/FileManagerImages/static-1.36437",
  "video-components": "/video-components/static-1.12939",
  "crm-export-dialog": "/crm-export-dialog/static-1.6192",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6331",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1636",
  "tanstack-virtual": "/tanstack-virtual/static-1.28",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2111",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2430",
  "whisper-core-api": "/whisper-core-api/static-1.6297",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14521",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5280",
  "settings-content-modals": "/settings-content-modals/static-1.45779",
  "crm_universal": "/crm_universal/static-1.21824",
  "customer-data-email": "/customer-data-email/static-1.17852",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36844",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39214",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11597",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54370",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21168",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17430",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71595",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5470",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5230",
  "utility-belt": "/utility-belt/static-1.2436",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22331",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7321",
  "customer-data-rte": "/customer-data-rte/static-1.32725",
  "cv-backend-services": "/cv-backend-services/static-1.1537",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5527",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5007",
  "qrcode-generator": "/qrcode-generator/static-1.67",
  "quotes-client-types": "/quotes-client-types/static-1.37685",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35368",
  "sales-views-client-types": "/sales-views-client-types/static-1.4159",
  "hub-http-contrib": "/hub-http-contrib/static-1.2939",
  "interframe": "/interframe/static-3.4659",
  "tinymce-data": "/tinymce-data/static-1.40148",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5107",
  "layout-dnd-components": "/layout-dnd-components/static-1.12242",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11217",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14773",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8984",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4428",
  "video-embed": "/video-embed/static-1.35428",
  "social-insights-client-types": "/social-insights-client-types/static-1.21774",
  "deal-intel-utils": "/deal-intel-utils/static-1.1640",
  "checkout-sdk": "/checkout-sdk/static-3.23404",
  "checkout-service-types": "/checkout-service-types/static-1.3742",
  "company-details-components": "/company-details-components/static-1.6081",
  "payment-method-components": "/payment-method-components/static-1-sai-jledford-autofill-pos-ae9c.3",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13252",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3370",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3423",
  "access-control-lib": "/access-control-lib/static-1.10334",
  "EmailComponents": "/EmailComponents/static-1.54466",
  "EmailData": "/EmailData/static-1.53143",
  "redux-less": "/redux-less/static-2.9380",
  "sequences-lib": "/sequences-lib/static-1.7861",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10244",
  "products-ui-components": "/products-ui-components/static-1.39665",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80316",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6894",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54386",
  "commerce-products-api": "/commerce-products-api/static-1.2133",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56444",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102273",
  "stripe-connect-js": "/stripe-connect-js/static-1.66",
  "draft-content-plugins": "/draft-content-plugins/static-1.27992",
  "ContentData": "/ContentData/static-1.68107",
  "layout-data-lib": "/layout-data-lib/static-1.9542",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3886",
  "outpost": "/outpost/static-1.4091",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.785",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3826",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18386",
  "pricing-pages-api": "/pricing-pages-api/static-1.13117",
  "ContentComponents": "/ContentComponents/static-2.70988",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9521",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1837",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.45939",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.801",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18566",
  "automation-ui-types": "/automation-ui-types/static-1.19484",
  "messaging-types-lib": "/messaging-types-lib/static-1.45676",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4399",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7718",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.415",
  "property-description-translator": "/property-description-translator/static-1.3749",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9080",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3552",
  "totals-ui-components": "/totals-ui-components/static-1.23291",
  "advanced-menus-core": "/advanced-menus-core/static-1.14967",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11929",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33753",
  "demographics-service-types": "/demographics-service-types/static-1.1548",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5400",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7236",
  "data-token-views": "/data-token-views/static-1.16203",
  "forms-utils-lib": "/forms-utils-lib/static-1.12384",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12825",
  "simple-menus-core": "/simple-menus-core/static-1.14966",
  "simple-menus-lib": "/simple-menus-lib/static-1.16483",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4150",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6670",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3417",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2552",
  "ContentEditorUI": "/ContentEditorUI/static-2.76806",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3877",
  "web-interactives-components": "/web-interactives-components/static-1.13582",
  "web-interactives-data": "/web-interactives-data/static-1.13583",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.250",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.420",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.872",
  "FireAlarmUi": "/FireAlarmUi/static-1.4425",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4082",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3732",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21420",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.20883",
  "data-studio-ubb": "/data-studio-ubb/static-1.2419",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26722",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57468",
  "content-management-data-lib": "/content-management-data-lib/static-1.5255",
  "copilot-plugins": "/copilot-plugins/static-1.10809",
  "cta-picker": "/cta-picker/static-1.36127",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2758",
  "editor-components": "/editor-components/static-1.13079",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8258",
  "error-messaging-js": "/error-messaging-js/static-1.5088",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85569",
  "pictos": "/pictos/static-7.182",
  "react-transition-group": "/react-transition-group/static-2.63",
  "redux-request-state": "/redux-request-state/static-1.10542",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1647",
  "smart-content-core": "/smart-content-core/static-1.42154",
  "smart-content-lib": "/smart-content-lib/static-1.42807",
  "social-composer-lib": "/social-composer-lib/static-1.58556",
  "structured-content-lib": "/structured-content-lib/static-1.24911",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.52966",
  "tinymce-copilot": "/tinymce-copilot/static-1.16131",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7756",
  "automation-ui-routing": "/automation-ui-routing/static-1.20841",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5556",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.41925",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3055",
  "reporting-enablement": "/reporting-enablement/static-1.22498",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20789",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2265",
  "forms-ai-lib": "/forms-ai-lib/static-1.4155",
  "codemirror-dlb": "/codemirror-dlb/static-1.58365",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6324",
  "report-customization-components": "/report-customization-components/static-1.12826",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12599",
  "html-to-image": "/html-to-image/static-1.52",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1408"
}
};
